import spikeViewApiService from "../../services/apiService";
import {
  LOGIN,
  LOGOUT,
  GET_ALL_COMPETENCY,
  UPDATE_USER_PERSONAL_INFO,
  // GET_STUDENT_COUNT,
  // GET_TEACHER_COUNT,
  GET_DASHBOARD_COUNT
} from "../types";

export const actionLogin = (data) => async (dispatch) => {
  const request = await spikeViewApiService("login", data);

  dispatch({ type: LOGIN, payload: request.data });
  return request;
};

export const actionLogout = (data) => async (dispatch) => {
  const request = await "test";
  dispatch({ type: LOGOUT, payload: request.data });
  return request;
};

export const actionUpdateUserInfo = (data) => async (dispatch) => {
  const request = data;
  dispatch({ type: UPDATE_USER_PERSONAL_INFO, payload: request });
  return request;
};

export const actionGetAllCompetency = () => async (dispatch) => {
  const request = await spikeViewApiService("getAllCompetency");
  dispatch({ type: GET_ALL_COMPETENCY, payload: request.data });
  return request;
};

export const uiTheme = (data) => async (dispatch) => {
  const request = await spikeViewApiService("uiTheme", data);
  dispatch({ type: "UI_THEME", payload: request.data });
  return request;
};

// export const actionStudentCount = (data) => async (dispatch) => {
//   const request = data;
//   dispatch({ type: GET_STUDENT_COUNT, payload: request });
//   return request;
// };

// export const actionTeacherCount = (data) => async (dispatch) => {
//   const request = data;
//   dispatch({ type: GET_TEACHER_COUNT, payload: request });
//   return request;
// };

export const actionGetDashboardCount = (apiName, data) => async (dispatch) => {
  const request = await spikeViewApiService(apiName, data);
  dispatch({ type: GET_DASHBOARD_COUNT, payload: request.data });
  return request;
};
